import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'Shared/components';
import { StateWithLabel } from 'Admin/components/StateWithLabel';
import { LicenseStatus } from 'Admin/components/LicenseStatus';
import { UserType } from 'Admin/Users/types';

import styles from './styles.module.css';

export const UserLicenses: FC<{
  licenses: UserType['licenses'];
  partnerId?: string;
}> = ({ licenses, partnerId }) => {
  return (
    <div className={styles.wrapper}>
      <h3>State License Authorizations</h3>
      <p>
        D.O.I. License Status is based on the agent's NPN entered above. Agent
        state licenses must be active in a non-revoked status and carry the
        correct LOA to be permitted for quoting & servicing Clearcover insurance
        products. If you believe a state license status is incorrect, please
        confirm the NPN above is accurate and contact the respective state
        D.O.I. Your agency's state license authorizations and permissions can be
        seen on the{' '}
        <Link
          to={`/admin/partners/${partnerId}/compliance`}
          className={styles.link}
        >
          Compliance page
        </Link>{' '}
        in our portal.
      </p>
      <Table
        name="user-state-license-authorizations-table"
        className={styles.table}
        columnWidths={[1, '250px']}
        headers={['State', 'D.O.I License Status']}
        rows={(licenses || []).map(({ state, status }) => {
          return {
            key: state,
            className: styles.stateRow,
            data: [
              <StateWithLabel state={state} />,
              <LicenseStatus status={status} />,
            ],
          };
        })}
      />
    </div>
  );
};
